//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BlendFactor",0,"Expression",0],[0,"CurvatureSensitivity",1,0],[1,"FacetSelection",0,"SelectDisplayableObjectList",0]],[[["nPlaneColor"],"GetPlaneColor",{R_:{planeColor:""}},0,0],[["planeColor"],"SetPlaneColor",{},1,0],[["nSphereColor"],"GetSphereColor",{R_:{sphereColor:""}},0,0],[["sphereColor"],"SetSphereColor",{},1,0],[["nCylinderColor"],"GetCylinderColor",{R_:{cylinderColor:""}},0,0],[["cylinderColor"],"SetCylinderColor",{},1,0],[["nConeColor"],"GetConeColor",{R_:{coneColor:""}},0,0],[["coneColor"],"SetConeColor",{},1,0],[["nBlendColor"],"GetBlendColor",{R_:{blendColor:""}},0,0],[["blendColor"],"SetBlendColor",{},1,0],[["nOtherColor"],"GetOtherColor",{R_:{otherColor:""}},0,0],[["otherColor"],"SetOtherColor",{},1,0],[[],"AdjustShapeBoundary",{},0,0]],[]];
SPLM.Facet.DetectPrimitivesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.DetectPrimitivesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;